<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          پیام ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="2" v-if="can('newMessage')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <div v-if="showDialog">
              <create-message :model-items="data" :dialogStatus.sync="showDialog"/>
            </div>
          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4"
                 class="d-inline-flex">
            <v-text-field
                clearable
                @click:clear="clearable"
                outlined
                dense
                placeholder="عنوان، نام مجتمع"
                v-model="searchvalue"
            />
            <v-btn fab small color="primary" @click="fillDataItems" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>


          </v-col>
          <v-col class="d-sm-inline-block" cols="12" sm="12"
                 md="6">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>
        </v-row>
        <v-row>
          <v-tabs
              color="deep-purple accent-4"
              v-model="tab" @change="fillDataItems">
            <v-tab href="#tab1">
              دریافتی
            </v-tab>
            <v-tab href="#tab2" v-if="can('newMessage')">
              ارسالی
            </v-tab>

            <v-tabs-items v-model="tab">
              <v-tab-item value="tab1">
                <v-container fluid>

                  <v-card-text>
                    <b-table
                        v-if="can('messageList')"
                        :items="receiverList"
                        :fields="columns"
                        stacked="md"
                        show-empty
                        responsive striped
                    >

                      <template #cell(read)="row">
                        <v-btn depressed small v-if="row.item.isRead" color="success">
                          خوانده شده
                        </v-btn>
                        <v-btn depressed small v-if="!row.item.isRead" color="danger">
                          خوانده نشده
                        </v-btn>
                      </template>

                      <template #cell(actions)="row">

                        <v-btn depressed small color="primary" @click="readMsgForReceiver(row.item.msgId)"
                               class="mr-1 ">
                          مشاهده
                        </v-btn>

                      </template>


                    </b-table>
                  </v-card-text>
                </v-container>
              </v-tab-item>
              <v-tab-item value="tab2">
                <v-container fluid>
                  <v-card-text>
                    <b-table
                        v-if="can('messageList')"
                        :items="senderList"
                        :fields="columns"
                        stacked="md"
                        show-empty
                        responsive striped
                    >
                      <template #cell(read)="row" v-if="userType==='user'">
                        <v-btn depressed small v-if="row.item.isRead" color="success">
                          خوانده شده
                        </v-btn>
                        <v-btn depressed small v-if="!row.item.isRead" color="danger">
                          خوانده نشده
                        </v-btn>
                      </template>

                      <template #cell(actions)="row">
                        <v-btn depressed small v-if="can('editMessage')" color="warning"
                               :to="{ name: 'detailMsg', query: { id:row.item.msgId } }" class="mr-1 ">
                          لیست
                        </v-btn>
                        <v-btn depressed small color="primary" @click="readMsgForSender(row.item.msgId)" class="mr-1 ">
                          مشاهده
                        </v-btn>
                        <v-btn depressed class="mr-1" v-if="can('deleteMessage')" small color="error"
                               @click="remove(row.item)">
                          حذف
                        </v-btn>

                      </template>
                    </b-table>
                  </v-card-text>
                </v-container>
              </v-tab-item>

            </v-tabs-items>
          </v-tabs>
        </v-row>

        <div v-if="showMsg">
          <see-msg :model="model" :showMsg.sync="showMsg"/>
        </div>

      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateMessage from './PageEdit'
import SeeMsg from './SeeMsg'
import Message_se from "./Message_se";
import {mapMutations} from "vuex";


export default {
  name: 'Manager',
  components: {
    CreateMessage,
    SeeMsg
  },

  data() {
    return {
      tab: 'tab1',
      searchvalue: '',
      userType: '',
      modelId: '',
      data: {},
      model: {},
      showDialog: false,
      showMsg: false,
      receiverList: [],
      senderList: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,

      columns: [
        {key: 'title', label: 'عنوان', sortable: true, sortDirection: 'desc'},
        {key: 'dateText', label: 'تاریخ ارسال'},
        {key: 'buildingName', label: 'نام مجتمع'},
        {key: 'read', label: 'وضعیت'},
        {key: 'actions', label: 'عملیات'},
      ],

    };

  },

  mounted() {
    this.$root.$on('Message', () => {
      this.fillDataItems()
    })

  },

  methods: {

    close() {
      this.searchvalue = ""
      this.$root.$emit('Message')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    fetch() {
      Message_se.getById(this.modelId).then(response => {
        this.data = response.data
      })
      this.showDialog = true;
    },

    readMsgForSender: function (msgId) {
      this.modelId = msgId
      this.showMsg = false
      Message_se.readMessageForSender(this.modelId).then(res => {
        this.model = res.data
      })
      this.showMsg = true
    },
    readMsgForReceiver: function (msgId) {
      this.modelId = msgId;
      this.showMsg = false
      Message_se.readMsgForReceiver(this.modelId).then(res => {
        this.model = res.data
      })
      this.showMsg = true
    },

    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Message_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },
    clearable() {
      this.searchvalue = ''
      this.fillDataItems()
    },
    fillDataItems() {
      Message_se.getPage(this.skip - 1, this.take, this.searchvalue, this.tab).then(response => {
        this.userType = response.data.userType
        this.paging = response.data.page
        this.receiverList = response.data.receiverList
        this.senderList = response.data.senderList

      });
    },

  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
